module.exports = __webpack_public_path__ + "img/c-thermometer-img8-1.a6b44dfb.png";